/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Frame_Rate_HelpInputs */

const en_options_general_frame_rate_help = /** @type {(inputs: Options_General_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The project frame rate can only be changed using the frame rate option under the Timecode menu`)
};

const fr_options_general_frame_rate_help = /** @type {(inputs: Options_General_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fréquence d'images du projet ne peut être modifiée que via l'option de fréquence d'images dans le menu Code temporel`)
};

const de_options_general_frame_rate_help = /** @type {(inputs: Options_General_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Bildrate des Projekts kann nur über die Option „Bildrate“ im Menü „Timecode“ geändert werden.`)
};

const it_options_general_frame_rate_help = /** @type {(inputs: Options_General_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il frame rate del progetto può essere modificato solo utilizzando l'opzione frame rate nel menu Timecode`)
};

const ru_options_general_frame_rate_help = /** @type {(inputs: Options_General_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частоту кадров проекта можно изменить только с помощью параметра «Частота кадров» в меню «Таймкод».`)
};

const es_options_general_frame_rate_help = /** @type {(inputs: Options_General_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La velocidad de cuadros del proyecto solo se puede cambiar mediante la opción de velocidad de cuadros en el menú Código de tiempo`)
};

const zh_cn2_options_general_frame_rate_help = /** @type {(inputs: Options_General_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目帧速率只能通过“时间码”菜单下的“帧速率”选项进行更改。`)
};

const ja_options_general_frame_rate_help = /** @type {(inputs: Options_General_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのフレームレートは、タイムコードメニューのフレームレートオプションを使用してのみ変更できます。`)
};

const hi_options_general_frame_rate_help = /** @type {(inputs: Options_General_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट फ्रेम रेट को केवल टाइमकोड मेनू के अंतर्गत फ्रेम रेट विकल्प का उपयोग करके ही बदला जा सकता है।`)
};

const pt_pt2_options_general_frame_rate_help = /** @type {(inputs: Options_General_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A taxa de quadros do projeto só pode ser alterada usando a opção "Taxa de quadros" no menu "Código de tempo".`)
};

/**
* | output |
* | --- |
* | "The project frame rate can only be changed using the frame rate option under the Timecode menu" |
*
* @param {Options_General_Frame_Rate_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_frame_rate_help = /** @type {((inputs?: Options_General_Frame_Rate_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Frame_Rate_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_frame_rate_help(inputs)
	if (locale === "de") return de_options_general_frame_rate_help(inputs)
	if (locale === "it") return it_options_general_frame_rate_help(inputs)
	if (locale === "ru") return ru_options_general_frame_rate_help(inputs)
	if (locale === "es") return es_options_general_frame_rate_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_frame_rate_help(inputs)
	if (locale === "ja") return ja_options_general_frame_rate_help(inputs)
	if (locale === "hi") return hi_options_general_frame_rate_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_frame_rate_help(inputs)
	return en_options_general_frame_rate_help(inputs)
});